module.exports = __webpack_public_path__ + "static/img/103072.6107b884.png";